<template lang="pug">
  section.pa-2
    v-row
      v-col
        v-btn(depressed text block @click.prevent="dialog = true")
          v-icon(left) mdi-playlist-edit
          | ändern
      v-col(v-if="secondClickText")
        v-btn.blue(depressed block @click="$emit('secondClickAction')")
          v-icon(left v-if="secondClickIcon") {{secondClickIcon}}
          | {{secondClickText}}
    v-dialog(
      width="980"
      v-model="dialog"
      @click:outside="closeDialog"
      transition="scroll-y-transition"
      :overlay-opacity="0.9"
    )
      v-card
        v-toolbar.transparent(flat)
          v-app-bar-nav-icon(@click="closeDialog")
            v-icon mdi-close
          v-toolbar-title {{this.title}}
          v-spacer
          v-btn.primary(depressed @click="changeText") ändern
        v-divider
        v-card-text.mt-4
          vue-editor(v-model="selectedText" width="600")
</template>


<script>
import { VueEditor } from "vue2-editor";
import { registerQuillFormats } from "@/plugins/quill-config";

// Register custom Quill formats
registerQuillFormats();

export default {
  components: { VueEditor },
  props: [ 'title', 'text', 'secondClickText', 'secondClickIcon'],
  data() {
    return {
      dialog: false,
      selectedText: '',
    }
  },
  watch: {
    dialog(newVal){
      if(newVal){
        this.selectedText = this.text
      }
    }
  },
  methods: {
    changeText(){
      this.$emit('changeText', { text: this.selectedText})
      this.closeDialog()
    },
    setBudget(newText){
      this.$emit('changeText', this.stext, newText)
      this.closeDialog()
    },
    closeDialog(){
      this.dialog = false
    }
  }
}
</script>
